import {defineStore} from 'pinia';
import axios from 'axios';
import {API_BASE_URL} from "@/config";

export const useSiteStore = defineStore('siteStore', {
    state: () => ({
        sites: [],
    }),
    actions: {
        setSites(sites) {
            this.sites = sites;
        },
        async fetchSites(organisationSlug) {
            try {
                const response = await axios.get(
                    `${API_BASE_URL}/organisations/${organisationSlug}/sites`,
                    {withCredentials: true});
                this.setSites(response.data.sites);
            } catch (error) {
                console.error('Failed to fetch sites:', error);
            }
        },
    },
});